module.exports = __webpack_public_path__ + "static/media/35.77a9d8c0.jpg";